
namespace Gamification.Gamification {

    export interface ChecklistPickerOptions {
        hideChecklist?: number[];
    }

    @Serenity.Decorators.registerClass()
    export class ChecklistCheckGrid extends Serenity.EntityGrid<ChecklistRow, ChecklistPickerOptions> {
        protected getColumnsKey() { return ChecklistColumns.columnsKey; }
        protected getDialogType() { return ChecklistDialog; }
        protected getIdProperty() { return ChecklistRow.idProperty; }
        protected getLocalTextPrefix() { return ChecklistRow.localTextPrefix; }
        protected getService() { return ChecklistService.baseUrl; }

        private rowSelection: Serenity.GridRowSelectionMixin;

        constructor(container: JQuery, options: ChecklistPickerOptions) {
            super(container, options);

            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));

            return columns;
        }

        protected usePager() {
            return true;
        }

        protected getInitialTitle() {
            return null;
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "refresh-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);
            return buttons;
        }

        get selectedItems() {
            return this.rowSelection.getSelectedKeys().map(x => this.view.getItemById(x));
        }

        onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            //
            var request = this.view.params as Serenity.ListRequest;
            //
            if (this.options.hideChecklist && this.options.hideChecklist.length) {
                /* */
                request.Criteria = Serenity.Criteria.and([[Gamification.ChecklistRow.Fields.IdChecklist], 'not in', [this.options.hideChecklist]], request.Criteria);
            }

            return true;
        }
    }
}